import { z } from 'zod/v4'
import { create } from 'zustand'
import { UnifiedDeepLinkData } from 'react-native-appsflyer'
const PartnerNameCode = z.string({ message: 'Partner name code is not a string' })

export const usePartnerNameCodeStore = create<{
  partnerNameCode: string | undefined
  setPartnerNameCodeFromDeepLink: (deepLinkData: UnifiedDeepLinkData['data']) => void
  clearPartnerNameCode: () => void
}>((set) => ({
  partnerNameCode: undefined,
  setPartnerNameCodeFromDeepLink: (deepLinkData: UnifiedDeepLinkData['data']) => {
    // https://dev.appsflyer.com/hc/docs/unifieddeeplink
    // From AppsFlyer, we only implemented Unified Deferred Linking, which only returns parameters: deep_link_value and deep_link_sub1-10.
    // If you try to get any other parameters (media_source, campaign, af_sub1-5, etc.), they return null.
    // Thus we will be using deep_link_sub1 to get the partner name code.
    const { data: partnerNameCode } = PartnerNameCode.safeParse(deepLinkData.deep_link_sub1)
    if (partnerNameCode) {
      set({ partnerNameCode })
    }
  },
  clearPartnerNameCode: () => set({ partnerNameCode: undefined }),
}))
